(function() {

  function detailSlider() {

    var $slider = $('.js-slideImg');
    var thumbnailItem = '.detailImage__thumbItem';
    var $thumbnailItem = $(thumbnailItem);

    // Add index number to thumbnail
    $thumbnailItem.each(function(){
     var index = $thumbnailItem.index(this);
     $(this).attr("data-index",index);
    });
    
    // Add current class to current thumbnail image
    $slider.on('init',function(slick){
     var index = $('.slide-item.slick-slide.slick-current').attr('data-slick-index');
     $(thumbnailItem+'[data-index="'+index+'"]').addClass('is-current');
    });
  
    $slider.slick({
      autoplay: false,
      arrows: false,
      fade: true,
      infinite: false
    });
    // switch slider
    $thumbnailItem.on('click',function(){
      var index = $(this).attr('data-index');
      $slider.slick('slickGoTo',index,false);
    });
    
    //Switch the current of thumbnail images
    $slider.on('beforeChange',function(event,slick, currentSlide,nextSlide){
      $thumbnailItem.each(function(){
        $(this).removeClass('is-current');
      });
      $(thumbnailItem+'[data-index="' + nextSlide + '"]').addClass('is-current');
    });
  }
  
  const isAboutDetailPage = $('.about-detail').length;
  if(isAboutDetailPage) {
    detailSlider();
  }
})();